export const defaultWebsocketStore = {
  isConnected: false,
  message: {
    event: "",
    data: {}
  },
  messages: [],
  retry: 0,
  reconnectError: false
};